"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUserRoleMutation = exports.useUpdateUserPermissionsMutation = exports.useUpdateUserFacilitiesMutation = exports.useUpdateOwnProfileMutation = exports.useResendUserCredentialsMutation = exports.useGetUsersQuery = exports.useGetUserQuery = exports.useGetMyProfileQuery = exports.useCreateUserMutation = exports.userApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var facility_1 = require("./facility");
exports.userApi = (0, react_1.createApi)({
    reducerPath: "userApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["users"],
    endpoints: function (builder) { return ({
        getUsers: builder.query({
            query: function (_a) {
                var role = _a.role, clientId = _a.clientId, size = _a.size, pageNumber = _a.pageNumber, search = _a.search, status = _a.status, sortBy = _a.sortBy, sortDirection = _a.sortDirection;
                return (0, api_url_1.appendUrlParams)("/v1/user", { role: role, client_id: clientId, size: size, pageNumber: pageNumber, search: search, status: status, sortBy: sortBy, sortDirection: sortDirection });
            },
            providesTags: ["users"],
        }),
        getUser: builder.query({
            query: function (id) { return "/v1/user/".concat(id); },
            providesTags: ["users"],
        }),
        getMyProfile: builder.query({
            query: function () { return "/v1/user/me"; },
            keepUnusedDataFor: 0,
            providesTags: ["users"],
        }),
        updateUserRole: builder.mutation({
            query: function (_a) {
                var id = _a.id, role = _a.role;
                return ({
                    url: "/v1/user/".concat(id, "/role"),
                    method: "PATCH",
                    body: { role: role },
                });
            },
            invalidatesTags: ["users"],
        }),
        updateUserPermissions: builder.mutation({
            query: function (_a) {
                var id = _a.id, permissions = _a.permissions;
                return ({
                    url: "/v1/user/".concat(id, "/permissions"),
                    method: "PATCH",
                    body: { permissions: permissions },
                });
            },
            invalidatesTags: ["users"],
        }),
        updateUserFacilities: builder.mutation({
            query: function (_a) {
                var id = _a.id, facilities = _a.facilities;
                return ({
                    url: "/v1/user/".concat(id, "/facilities"),
                    method: "PATCH",
                    body: { facilities: facilities },
                });
            },
            invalidatesTags: ["users"],
            // Saving a manager changes which facilities list them as managers.
            onQueryStarted: function (_argument_1, _a) {
                return __awaiter(this, arguments, void 0, function (_argument, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(facility_1.facilityApi.util.invalidateTags(["facility"]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        createUser: builder.mutation({
            query: function (body) { return ({
                url: "/v1/user",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["users"],
            // Saving a manager changes which facilities list them as managers.
            onQueryStarted: function (_argument_1, _a) {
                return __awaiter(this, arguments, void 0, function (_argument, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(facility_1.facilityApi.util.invalidateTags(["facility"]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        resendUserCredentials: builder.mutation({
            query: function (id) { return ({
                url: "/v1/user/".concat(id, "/resend-credentials"),
                method: "POST",
            }); },
        }),
        updateOwnProfile: builder.mutation({
            query: function (body) { return ({
                url: "/v1/user/me",
                method: "PATCH",
                body: body,
            }); },
            invalidatesTags: ["users"],
        }),
    }); },
});
exports.useCreateUserMutation = exports.userApi.useCreateUserMutation, exports.useGetMyProfileQuery = exports.userApi.useGetMyProfileQuery, exports.useGetUserQuery = exports.userApi.useGetUserQuery, exports.useGetUsersQuery = exports.userApi.useGetUsersQuery, exports.useResendUserCredentialsMutation = exports.userApi.useResendUserCredentialsMutation, exports.useUpdateOwnProfileMutation = exports.userApi.useUpdateOwnProfileMutation, exports.useUpdateUserFacilitiesMutation = exports.userApi.useUpdateUserFacilitiesMutation, exports.useUpdateUserPermissionsMutation = exports.userApi.useUpdateUserPermissionsMutation, exports.useUpdateUserRoleMutation = exports.userApi.useUpdateUserRoleMutation;
